import { useEffect, useContext, useState, useCallback } from 'react';
import Balls from '../../components/Balls';
import ErrorBox from '../../components/ErrorBox/ErrorBox';
import Main from '../../components/Main/Main';
import PoweredByVipps from '../../components/PoweredByVipps/PoweredByVipps';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import { AppContext } from '../../context';
import { Colors, wait } from '../../lib/util';
import './CompleteThreeDSV2.css';
import { completeThreeDS } from './utils';
import { ErrorState, mapError } from './error';

enum State {
  NOT_STARTED,
  LOADING,
  COMPLETED,
}

export default function CompleteThreeDSV2(): JSX.Element {
  const context = useContext(AppContext);
  const [loadingState, setLoadingState] = useState<State>(State.NOT_STARTED);

  const [error, setError] = useState<ErrorState | null>();

  const [interceptUrl, setInterceptUrl] = useState<string | null>(null);

  const redirect = useCallback(() => {
    interceptUrl && window.location.assign(interceptUrl);
  }, [interceptUrl]);

  const sendComplete3dsRequest = useCallback(async () => {
    const [errorDetails, returnUrl] = await completeThreeDS(context);
    if (!errorDetails) {
      await wait(1000);
      window.location.assign(returnUrl);
    } else {
      setError(mapError(errorDetails, context));
      setLoadingState(State.COMPLETED);
      setInterceptUrl(returnUrl);
    }
  }, [context]);

  useEffect(() => {
    if (loadingState === State.NOT_STARTED) {
      setLoadingState(State.LOADING);
      sendComplete3dsRequest();
    }
  }, [sendComplete3dsRequest, loadingState]);

  if (!error && [State.LOADING, State.NOT_STARTED].includes(loadingState)) {
    return (
      <Main footer={<PoweredByVipps />} className="complete-threed2-v2">
        <div className="fill"></div>
        <Balls color={Colors.Purple} />
        <div className="fill"></div>
      </Main>
    );
  }

  return (
    <Main footer={<PoweredByVipps />} className="complete-threed2-v2">
      <div className="fill"></div>
      <>{error && <ErrorBox error={error} />}</>
      <div className="fill two"></div>
      <PrimaryButton loading={false} disabled={false} onClick={redirect} color={Colors.Purple}>
        {context.texts.tryAgain}
      </PrimaryButton>
    </Main>
  );
}
